import { Link, NavLink } from 'react-router-dom';
import { PRIMARY_CALL_PHONE } from '@lib/businessContact';

export function DesktopHeader({ isScrolled, navigationLinks }) {
  return (
    <div className="hidden lg:flex items-center justify-between h-20">
      <div className="flex items-center">
        <Link to="/" className="relative group">
          <span className="text-3xl font-bold">
            <span className="text-[#7C3AED]">A</span>
            <span className={`${isScrolled ? 'text-[#06B6D4]' : 'text-white'}`}>vision</span>
            <span
              className={`block text-[10px] font-medium tracking-wider uppercase -mt-0.5 ${
                isScrolled ? 'text-white/60' : 'text-white/60'
              }`}
            >
              Commercial & Specialty Lighting · South Florida
            </span>
          </span>
        </Link>
      </div>

      <div className="flex items-center space-x-8">
        {navigationLinks.map((link) => (
          <NavLink
            key={link.path}
            to={link.path}
            className={({ isActive }) => `
              relative px-3 py-2
              text-base font-medium
              transition-colors duration-200
              ${
                isActive
                  ? 'text-[#06B6D4]'
                  : isScrolled
                    ? 'text-white/80 hover:text-[#06B6D4]'
                    : 'text-white hover:text-[#06B6D4]'
              }
            `}
          >
            {link.label}
          </NavLink>
        ))}

        <a
          href={PRIMARY_CALL_PHONE.tel}
          className={`
                px-6 py-2.5 rounded-full font-semibold transition-colors duration-200
                ${
                  isScrolled
                    ? 'bg-[#7C3AED] text-white hover:bg-[#6D28D9]'
                    : 'bg-white/10 text-white hover:bg-white/20 border border-white/20'
                }
            `}
          aria-label={`Call ${PRIMARY_CALL_PHONE.display}`}
        >
          <i className="fas fa-phone mr-2" />
          Call Now
        </a>
      </div>
    </div>
  );
}
